export const highContrast = `
  <style>
    [theme="high_contrast"] {

      --white-layout-300-primary: #FFFFFF;
      --white-layout-301-level-0-elevation: #0E1416;
      --white-layout-302-level-1-elevation: #121719;
      --white-layout-303-level-2-elevation: #171D21;
      --white-layout-304-text: #FFFFFF;
      --white-layout-305-disabled-text: #ffffff99; /* white 60% */
      --white-layout-306-primary-hc: #000000;
      --white-layout-200-secondary: #000000;
      --white-layout-302-active-focus: #349DF726;
      --white-layout-201-secondary-on-dark-background: #FFFFFF;
      --white-layout-250-disabled-text-on-blue-background: #ffffffbf;
      --white-layout-100-disabled: #00000080;
      --white-layout-101-outline-on-dark-background: #ffffff99;/* white 60% */
      --white-layout-050-hover-on-dark-background: #ffffff40;/* white 25% */
      --white-layout-010-hover-primary: #ffffff33;/* white 20% */
      --white-layout-011-hover-on-blue-background: #ffffff26;/* white 15% */
      --white-layout-012-hover-on-blue-background: #ffffff1a;/* white 10% */
      --white-layout-005-background-for-icon-menu: #ffffff1a;/* white 10% */;
      --white-layout-001-hover-on-blue-background: #ffffff33;/* white 20% */
      --white-layout-002-light-background-on-dark-theme: #ffffff08;/* white 3% */

      --grey-layout-020-side-panel-background: #1D1D1D;
      --grey-layout-500-neutral-background: #FFFFFF;
      --grey-layout-501-neutral-background: #3C3C3C;
      --black-layout-700-primary: #FFFFFF;
      --black-layout-701-primary: #000000;

      --main-titles-inputs-600: #FFFFFF;
      --main-titles-inputs-601: #FF0000;
      --main-titles-inputs-602: #ffffffcc;/* white 80% */
      --main-titles-inputs-603: #000000;

      --body-text-arrows-400: #FFFFFF;
      --body-text-arrows-401: #000000;

      --chart-300-icon-buttons: #FFFFFF;
      --chart-301-icon-buttons: #FFFFFF;
      --chart-302-icon-buttons-titles: #ffffffbf;/* white 75% */
      --chart-303-icon-buttons-titles: #ffffff80;/* white 50% */
      --chart-304-icon-buttons: #000000bf;/* black 75% */
      --chart-305-icon-buttons: #000000e6;/* black 90% */

      --grey-layout-200-disabled: #ffffff80;
      --grey-layout-201-disabled-text: #0000008c;/* black 55% */
      --grey-layout-202-disabled-icons: #ffffff4d;/* white 30% */
      --grey-layout-203-dark-theme-disabled-text: #ffffff73;/* white 45% */

      --chart-100-pressed: #ffffff59;/* white 35% */
      --chart-101-pressed-dividers: #ffffff33;
      --chart-102-pressed: #ffffff0d;/* white 5% */
      --chart-103-pressed: #ffffff26;/* white 15% */
      --chart-104-pressed: #ffffff2e;/* white 18% */
      --chart-105-solid: #C2C2C2;

      --chart-050-hover: #fffdf01a;
      --chart-051-hover: #ffffff4d;/* white 30% */
      --chart-052-graph-background: #0E131A;

      --blue-layout-500-focus: #FFD84A;
      --blue-layout-501-focus: #065CC1;
      --blue-layout-502-focus: #B3D3FF;
      --blue-layout-503-focus-on-dark-background-hc: #B3D3FF;
      --blue-layout-504-focus-on-dark-background-light-theme: #FFD84A;

      --blue-layout-400-primary: #2F9EFF;
      --blue-layout-401-primary: #FF0000;
      --blue-layout-402-primary-background: #0064EA;
      --blue-layout-403-primary: #196BD8;
      --blue-layout-404-primary: #004CB1;
      --blue-layout-405-primary-hc-on-light-background: #B6D0FF;

      --blue-layout-300-active: #2485D9;
      --blue-layout-301-active: #41B4F6;
      --blue-layout-302-active-focus: #52aeff1a;
      --blue-layout-303-active: #349df7a6;
      --blue-layout-304-active: #006DFF;
      --blue-layout-305-active: #349df740;
      --blue-layout-306-active: #8CCAFF;
      --blue-layout-307-active-hc: #9AD0FF;
      --blue-layout-308-active-hc: #30A9FF;

      --blue-layout-200-disabled: #ffffff1f;/* white 12% */
      --blue-layout-201-disabled: #006dff66;
      --blue-layout-202-disabled: #e4f2ffa6;
      --blue-layout-203-disabled: #006dff80;

      --blue-layout-100-background: #13161cbf;
      --blue-layout-101-background: #ffffff40;/* white 25% */
      --blue-layout-102-background: #006dff59;
      --blue-layout-103-background: #d4e7ff33;
      --blue-layout-104-solid-background: #262C35;

      --blue-layout-050-selected: #ffffff33;/* white 20% */
      --blue-layout-051-selected: #ffffff66;/* white 40% */

      --dark-blue-700-main-menu: #090E13;
      --dark-blue-701-main-menu-dark-background: #ffffff14;/* white 8% */
      --dark-blue-702-main-menu: #20252B;
      --dark-blue-703-main-menu: #ffffff80;/* white 50% */

      --dark-blue-600-secondary-menu: #202C3D;

      --red-layout-001-logo: #FF0000;
      --red-layout-300-primary: #FE3E3E;
      --red-layout-301-primary: #FF5B63;
      --red-layout-302-primary: #D54143;
      --red-layout-303-primary: #FF6F6F;
      --red-layout-200-hover: #ec5b62b3;
      --red-layout-201-hover: #ec5b6280;
      --red-layout-100-disabled: #ec5b6280;
      --red-layout-101-disabled: #ef6a70cc;
      --red-layout-102-disabled: #ec5b6233;
      --red-layout-050-background: #ec5b621a;
      --red-layout-051-background: #ec5b6233;

      --green-layout-100-primary-green: #32C092;
      --green-layout-101-primary-green: #65C5A6;
      --green-layout-102-primary-green-hc: #17805E;
      --green-layout-050-secondary-green: #1f8463d9;

      --orange-layout-050-warning: #FFAA45;
      --yellow-layout-200-text-highlight: #FFD23D;
      --red-alert-chart-700-critical: #A8252B;
      --red-alert-500-severe: #FF0000;
      --orange-alert-chart-100: #FF8833;
      --yellow-alert-050: #FFE659;
      --green-pastel-alert-chart-050-healty: #84EF42;

      --gradient-400-main-blue: #c2d1ea33;
      --gradient-401-main-blue: #c2d1eab3;

      --gradient-300-light-main-blue: #c5d4ec33;
      --gradient-301-light-main-blue: #c5d4ecb3;

      --gradient-200-secondary-blue: #d1dcf033;
      --gradient-201-secondary-blue: #d1dcf0b3;

      --gradient-100-light-secondary-blue: #e7eef833;
      --gradient-101-light-secondary-blue: #e7eef8b3;

      --gradient-050-light-blue: #f6fafd33;
      --gradient-051-light-blue: #f6fafdb3;

      --gradient-010-very-light-blue: #fcfcfc33;
      --gradient-011-very-light-blue: #fcfcfcb3;

      --grey-layout-chart-100: #ffffff33;/* white 20% */;
      --red-chart-600: #F02A42;
      --red-chart-400: #EF5350;
      --yellow-chart-050: #FFB74D;
      --green-chart-050: #00CC66;

      --green-teal-chart-400: #029384;
      --green-teal-chart-300: #2EAC9D;
      --green-teal-chart-200: #00A19B;
      --green-teal-chart-100: #00BBB4;
      --green-teal-chart-050: #00CCBD;

      --teal-chart-400: #1B8AA8;
      --teal-chart-300: #2898B2;
      --teal-chart-200: #35A9BC;
      --teal-chart-100: #44BAC6;
      --teal-chart-050: #74D6DB;

      --blue-chart-500: #295CA5;
      --blue-chart-400: #366EB2;
      --blue-chart-300: #4480BC;
      --blue-chart-200: #5493C6;
      --blue-chart-100: #65A6D1;
      --blue-chart-050: #67B7DC;

      --sky-blue-chart-050: #3AA1CC;
      --indigo-blue-chart-050: #6771DC;
      --purple-chart-050: #A367DC;

      --focus-bg-color: #349DF726;
      --background-transparent: #fff0;

    /*--------------------------GZ-DATE-PICKER---------------------------------*/
      --gz-datepicker-hovered-cell-color: #252D35;
    /*-------------------------VAADIN-GRID---------------------------------*/
      --reorder-ghost-background: #F2F2F2;
    /*--------------------------GZ-LOADER---------------------------------*/
      --gz-loader-background: #ffffff40;
      --gz-loader-animation-bg: #2C3137;
    /*--------------------------GZ-PHONE-INPUT---------------------------------*/
    --gz-phone-input-border-color: #4a4e54;
    }
  </style>
`;
